module.exports = __webpack_public_path__ + "static/media/LoyalityProgramsCards.7c7cc760.png";